// src/services/baseService.ts
import { TeamsMembersResponse } from "../features/teamsMembers/teamsMemberTypes";
import { del, get, put } from "../utils/api";
import { formatUrl } from "../utils/urlFormatter";

const fetch_teams_members_list = "/{0}/teamMember.list";
const base_team_member_invitation_status = "/team/{0}/{1}/invitations";
const base_team_member_remove = "/team/invite/{0}/{1}/delete";
const update_team_member = "/{0}/teamMember.update";
const delete_team_member = "/{0}/teamMember.delete";

const credentialsConfig = {
  withCredentials: true,
};

export const fetchTeamsMembersData = async (
  teamId: number, role:string
): Promise<TeamsMembersResponse> => {
  let fetch_members_data = formatUrl(fetch_teams_members_list, [teamId]);


  if (role) {
    fetch_members_data += `?role=${role}`;
  }

  return get<TeamsMembersResponse>(fetch_members_data, credentialsConfig);
};

export const fetchBaseTeamMemberInvitationStatus = async (
  baseId: number,
  teamId: number,
): Promise<TeamsMembersResponse> => {
  const team_invitation_status = formatUrl(base_team_member_invitation_status, [
    baseId,
    teamId,
  ]);
  return get<TeamsMembersResponse>(team_invitation_status, credentialsConfig);
};

export const deleteTeamMemberInvitation = async (
  baseId: number,
  invitationId: number,
): Promise<TeamsMembersResponse> => {
  const formattedUrl = formatUrl(base_team_member_remove, [
    baseId,
    invitationId,
  ]);
  return del<TeamsMembersResponse>(formattedUrl, credentialsConfig);
};

export const updateTeamMember = async (
  baseId: number,
  team_id: number,
  data: any,
): Promise<TeamsMembersResponse> => {
  const formattedUrl = formatUrl(update_team_member, [baseId, team_id]);
  return put<TeamsMembersResponse>(formattedUrl, data, credentialsConfig);
};

export const deleteTeamMember = async (
  team_id: number,
): Promise<TeamsMembersResponse> => {
  const formattedUrl = formatUrl(delete_team_member, [team_id]);
  return del<TeamsMembersResponse>(formattedUrl, credentialsConfig);
};
